/**
 * Verlauf einer Bewertung 1-10 (D-04): eine Zelle je Zeitraum (Tag, Woche,
 * Monat) in der Farbe der Skala. Zeitraeume ohne Wert sind neutral und sehen
 * nicht wie ein schlechter aus; die Zahl steht im Tooltip und fuer
 * Screenreader. Ein Baustein fuer Journal und Reflexionen (Leitlinie 6).
 */
import { skalaFarbe } from '@/domain/rating';

export interface SkalaPunkt {
  key: string;
  /** z. B. "Mo 21.09." oder "KW 38" */
  titel: string;
  wert?: number;
}

export function SkalaStreifen({ label, punkte, zusatz, hoehe = 'h-5' }: {
  label: string;
  punkte: SkalaPunkt[];
  /** Rechts neben dem Namen, z. B. "7 Tage: 6,5". */
  zusatz?: string;
  hoehe?: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-baseline gap-2 text-[11px]">
        <span className="flex-1 text-ink-muted">{label}</span>
        {zusatz && <span className="tabular-nums text-ink-faint">{zusatz}</span>}
      </div>
      <ol aria-label={`${label}, Verlauf`} className="flex gap-0.5">
        {punkte.map((p) => {
          const text = `${p.titel}: ${p.wert === undefined ? 'kein Eintrag' : `${p.wert.toLocaleString('de-DE', { maximumFractionDigits: 1 })} von 10`}`;
          return (
            <li
              key={p.key}
              title={text}
              aria-label={text}
              className={`${hoehe} flex-1 rounded-[2px] ${p.wert === undefined ? 'bg-line/35' : ''}`}
              style={p.wert === undefined ? undefined : { backgroundColor: skalaFarbe(p.wert) }}
            />
          );
        })}
      </ol>
    </div>
  );
}

/** Kleine Legende der Skala: 1 bis 10 in ihren Farben, dazu "kein Eintrag". */
export function SkalaLegende() {
  return (
    <div aria-label="Farbskala 1 bis 10" className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[10px] text-ink-faint">
      <span>1 schlecht</span>
      <span className="flex gap-px">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
          <span key={n} title={String(n)} className="grid h-3.5 w-4 place-items-center rounded-[2px] text-[9px] font-medium text-canvas" style={{ backgroundColor: skalaFarbe(n) }}>{n}</span>
        ))}
      </span>
      <span>10 gut</span>
      <span className="flex items-center gap-1"><span className="inline-block h-3 w-3 rounded-[2px] bg-line/35" /> kein Eintrag</span>
    </div>
  );
}
